import PrivacyPolicy from "../../components/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
